/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import {
  formatTipoPreview,
  getResumoPorTipo,
  MAX_GRUPOS_CELULA,
} from './helpers';

const ItensDoDiaCell = ({ row, onOpenResumo }) => {
  const grupos = getResumoPorTipo(row);
  const visiveis = grupos.slice(0, MAX_GRUPOS_CELULA);
  const ocultos = Math.max(0, grupos.length - MAX_GRUPOS_CELULA);
  const totalItens = row?.totalItens;

  const handleOpen = event => {
    event.stopPropagation();
    onOpenResumo(row);
  };

  if (!grupos.length) {
    return (
      <Box
        onClick={handleOpen}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          cursor: 'pointer',
          minWidth: 0,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          -
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      onClick={handleOpen}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        minWidth: 0,
        cursor: 'pointer',
        py: 0.5,
        '&:hover .resumo-linha': { textDecoration: 'underline' },
      }}
    >
      <Stack spacing={0.25} sx={{ minWidth: 0 }}>
        {visiveis.map((grupo, index) => (
          <Typography
            key={grupo.tipoId || `${grupo.tipo}-${index}`}
            className="resumo-linha"
            variant="body2"
            noWrap
            title={formatTipoPreview(grupo)}
            sx={{ lineHeight: 1.35 }}
          >
            {formatTipoPreview(grupo)}
          </Typography>
        ))}
        {(ocultos > 0 || totalItens != null) && (
          <Typography variant="caption" color="primary.main" sx={{ lineHeight: 1.2 }}>
            {ocultos > 0 ? `+${ocultos} tipo${ocultos > 1 ? 's' : ''}` : 'Ver resumo'}
            {totalItens != null ? ` · ${totalItens} item${totalItens === 1 ? '' : 's'}` : ''}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

ItensDoDiaCell.propTypes = {
  row: PropTypes.object.isRequired,
  onOpenResumo: PropTypes.func.isRequired,
};

export default ItensDoDiaCell;
